import React from 'react';
import styled from 'styled-components';
import ActionsFormV2 from './actionsFormV2/ActionsFormV2';

import CenteredLoadingIndicator from '../common/CenteredLoadingIndicator';
import EmptyStateMessage from '../common/EmptyStateMessage';
import ActionsProjectSelection from './actionsFormV2/ActionsProjectSelection';
import _ from 'lodash';


const Content = styled.div`
    display: flex,
    justify-content:center;
`;


const ActionsMain = (props) => {


    return (
  <>
                                    <ActionsProjectSelection/>
                                    <ActionsFormV2 />


                                    </>
    )
}

export default ActionsMain;